"use strict";
// export type DB_Testv1_0_0 = DB_Object & { a: string, k: string, _c: string, _d: number }
// export type DB_Test = DB_Object & { a: string, b: string, _c: string, _d: number }
Object.defineProperty(exports, "__esModule", { value: true });
